import { render, staticRenderFns } from "./LaunchPad.vue?vue&type=template&id=0f50194a&scoped=true&"
import script from "./LaunchPad.vue?vue&type=script&lang=ts&"
export * from "./LaunchPad.vue?vue&type=script&lang=ts&"
import style0 from "./LaunchPad.vue?vue&type=style&index=0&id=0f50194a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f50194a",
  null
  
)

export default component.exports